import emptySplitApi from "../utils/rtk";
import { User, updateProfile } from "../types/User";
import { END_POINTS } from "../helpers";
import { CommonBody } from "../types/General";

type CommonResponseType = {
  data: any;
  status: number;
  message: string;
};

export const cmsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    addContact: builder.query<
      CommonResponseType & { data: any },
      { body: { email: string; phone_no: string; dialCode?: string } }
    >({
      query: ({ body }) => ({
        url: END_POINTS.addContact,
        method: "POST",
        body,
      }),
    }),
    postAddPrivacy: builder.query<
      CommonResponseType & { data: any | string },
      { body: { privacy_policy: any } }
    >({
      query: ({ body }) => ({
        url: END_POINTS.addPrivacy,
        method: "POST",
        body,
      }),
    }),
    postAddTerms: builder.query<
      CommonResponseType & { data: any | string },
      { body: any }
    >({
      query: ({ body }) => ({
        url: END_POINTS.termsCondition,
        method: "POST",
        body,
      }),
    }),
    postAddCookies: builder.query<
      CommonResponseType & { data: any | string },
      { body: any }
    >({
      query: ({ body }) => ({
        url: END_POINTS.cookies,
        method: "POST",
        body,
      }),
    }),
    postAddAboutUs: builder.query<
      CommonResponseType & { data: any | string },
      { body: any }
    >({
      query: ({ body }) => ({
        url: END_POINTS.cmsAboutUs,
        method: "POST",
        body,
      }),
    }),
    postAddAgreement: builder.query<
      CommonResponseType & { data: any | string },
      { body: any }
    >({
      query: ({ body }) => ({
        url: END_POINTS.addAgreement,
        method: "POST",
        body,
      }),
    }),
    postAddDataDeletion: builder.query<
      CommonResponseType & { data: any | string },
      { body: any }
    >({
      query: ({ body }) => ({
        url: END_POINTS.dataDeletion,
        method: "POST",
        body,
      }),
    }),
    getCms: builder.mutation<CommonResponseType, {}>({
      query: ({}) => ({
        url: `${END_POINTS.getCms}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetCmsMutation,
  useLazyAddContactQuery,
  useLazyPostAddPrivacyQuery,
  useLazyPostAddTermsQuery,
  useLazyPostAddCookiesQuery,
  useLazyPostAddAboutUsQuery,
  useLazyPostAddDataDeletionQuery,
  useLazyPostAddAgreementQuery,
} = cmsApi;
